import React, { useContext, useState } from 'react';

import * as S from './styles';
import { IProps } from './types';
import { Container, Row, Col } from 'react-bootstrap';
import HeaderLogo1 from './images/dailypoints-octoberfest.jpg';
import SubHeaderLogo from './images/dailypoints-sub.png';
import MyPointLogo from './images/mypoints.png';
import TotalPointLogo from './images/totalpoints.png';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { POINT_CAMPAIGN, POINT_CAMPAIGN_EVENT_CREATE } from '@components/pages/DailyMarketingPage/queries';
import { CredentialContext, credentialType } from '@providers';
import { Redirect } from 'react-router';
import { accountLoginUrl, baseUrl } from '@src/app/routes';
import { Button, Loading } from '@atoms';
import { getGraphqlIdFromDBId } from '@utils';
import { pointCampaign } from '@components/pages/DailyMarketingPage/__generated__/pointCampaign';
import { pointCampaignEventCreate } from '@components/pages/DailyMarketingPage/__generated__/pointCampaignEventCreate';
import { useAlert } from 'react-alert';
import { Link } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import { DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

const DailyMarketingPage: React.FC<IProps> = ({}: IProps) => {
  const { currentUser } = useContext<credentialType>(CredentialContext);
  const [open, setOpen] = React.useState(false);
  const [isError, setIsError] = React.useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const dbId = '2';
  const id = getGraphqlIdFromDBId(dbId, 'PointCampaign');
  const [disabled, setDisabled] = useState(true);
  const { data } = useQuery<pointCampaign>(POINT_CAMPAIGN, {
    variables: { id },
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      setDisabled(!data.pointCampaignAvailabilityCheck);
    },
  });

  const reactAlert = useAlert();
  const [createPointCampaignEvent] = useMutation<pointCampaignEventCreate>(POINT_CAMPAIGN_EVENT_CREATE, {
    onCompleted: (data) => {
      setDisabled(true);
      setOpen(true);
    },
  });

  const handleClick = (e: any) => {
    if (data.pointCampaignAvailabilityCheck) {
      createPointCampaignEvent({
        variables: {
          input: {
            campaign: id,
          },
        },
      });
    } else {
      setOpen(true);
      setIsError(true);
      // window.location.reload();
    }
  };

  return currentUser?.token ? (
    data ? (
      <Container>
        <Row>
          <Col md={{ span: 8, offset: 2 }} xs={12}>
            <S.ImageWrapper src={HeaderLogo1} />
            <S.ImageWrapper src={SubHeaderLogo} />
          </Col>
        </Row>
        <Row>
          <Col md={{ span: 6, offset: 2 }} xs={9}>
            <S.ImageWrapper src={TotalPointLogo} />
          </Col>
          <Col md={2} xs={3}>
            <S.PointWrapper>{data.pointCampaignEarnPointSum || 0}</S.PointWrapper>
          </Col>
        </Row>
        <Row>
          <Col md={{ span: 6, offset: 2 }} xs={9}>
            <S.ImageWrapper src={MyPointLogo} />
          </Col>
          <Col md={2} xs={3}>
            <S.PointWrapper>{data?.me?.point?.availableAmount || 0}</S.PointWrapper>
          </Col>
        </Row>
        <Row>
          <Col md={{ span: 6, offset: 3 }} xs={12}>
            <Button
              onClick={handleClick}
              fullWidth
              style={{
                marginTop: '2rem',
                marginBottom: '2rem',
                borderRadius: '13px',
              }}
            >
              Redeem Today's Point
            </Button>
            {/* alert */}
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              {isError == false ? (
                <DialogContent>
                  <DialogContentText id="alert-dialog-description" style={{ fontSize: '1.4rem' }}>
                    Congratulations!
                  </DialogContentText>
                  <DialogContentText id="alert-dialog-description" style={{ fontSize: '1.4rem' }}>
                    You have got today’s points & now you can use them while doing the payment.
                  </DialogContentText>
                </DialogContent>
              ) : (
                <DialogContent>
                  <DialogContentText id="alert-dialog-description" style={{ fontSize: '1.4rem' }}>
                    Thanks for participating, please join again tomorrow.
                  </DialogContentText>
                </DialogContent>
              )}
              <DialogActions style={{ justifyContent: 'center' }}>
                <Button style={{ borderRadius: '13px', marginRight: '10px' }} onClick={handleClose} autoFocus>
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </Col>
        </Row>
      </Container>
    ) : (
      <Loading />
    )
  ) : (
    <Redirect to={accountLoginUrl} />
  );
};

export { DailyMarketingPage };
